import React from "react";
import PropTypes from "prop-types";

import styles from "./ProductDetails.scss";
import ProductDetailsLabel from "./ProductDetailsLabel";
import ProductDetailsItem from "./ProductDetailsItem";
import ProductDetailsHeading from "./ProductDetailsHeading";
import ProductDetailsList from "./ProductDetailsList";
import ProductDetailsListSection from "./ProductDetailsListSection";
import { ThemeContext } from "../Theme";

export class ProductDetails extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    scheme: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  };

  static defaultProps = {
    scheme: "",
  };

  static displayName = "ProductDetails";

  static Variant = {
    themeDark: "productdetails--theme_dark",
  };

  static contextType = ThemeContext;

  static Heading = ProductDetailsHeading;

  static ListSection = ProductDetailsListSection;

  static Item = ProductDetailsItem;

  static Label = ProductDetailsLabel;

  static List = ProductDetailsList;

  render() {
    const { children, ...restProps } = this.props;
    let { scheme } = this.props;

    if (!scheme) {
      scheme = "";
    }

    if (this.context) {
      scheme += ` ${styles[this.context]}`;
    }

    return (
      <div className={`${styles.wrapper} ${scheme}`}>
        <div className={styles.list} {...restProps}>
          {children}
        </div>
      </div>
    );
  }
}

export default ProductDetails;
